import * as PIXI from "pixi.js";
import gsap from "gsap";
import ServiceLocator from "../../ServiceLocator";
import Button from "../../lib/Button";
import signals from "signals";
import { device_orientation_type } from "../../service/DeviceOrientation";


export default class TutorialPopup extends PIXI.Container
{
    // #region Attributes //

    // private:

    private _disabledBg: PIXI.Graphics = null;
    private _baseWrapper: PIXI.Container = null;
    private _base: PIXI.Sprite = null;
    //private _title: PIXI.Text = null;
    //private _message: PIXI.Text = null;
    private _dotContainer: PIXI.Container = null;
    private _selDot: PIXI.Sprite = null;
    private _prevBtn: Button = null;
    private _nextBtn: Button = null;
    private _closeBtn: Button = null;

    private _curIndex: number = null;

    private _swipeStartX: number = null;

    // Quick access.
    private _interactionManager: PIXI.InteractionManager = null;

    // Constants.
    private readonly _kMaxSlideCount: number = 3;

    // Signals.
    private _onClosed: signals.Signal = null;

    // #endregion //


    public get onClosed(): signals.Signal { return this._onClosed; }


    // #region Methods //

    // public:

    public constructor()
    {
        super();
    }

    public init(): void
    {
        this._onClosed = new signals.Signal();

        this._interactionManager = ServiceLocator.app.renderer.plugins.interaction as PIXI.InteractionManager;
        this._curIndex = 0;

        this._disabledBg = new PIXI.Graphics();
        this._disabledBg.beginFill( 0x000000, 0.8 );
        this._disabledBg.drawRect( -ServiceLocator.app.safeAreaMarginX, -ServiceLocator.app.safeAreaMarginY, ServiceLocator.app.safeAreaWidth, ServiceLocator.app.safeAreaHeight );
        this._disabledBg.endFill();
        this._disabledBg.interactive = true;
        this.addChild( this._disabledBg );

        this._baseWrapper = new PIXI.Container();
        this._baseWrapper.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this.addChild( this._baseWrapper );

        this._base = new PIXI.Sprite( ServiceLocator.resources[ "tut_module_" + this._curIndex.toString() ].texture );
        this._base.x = -this._base.width * 0.5;
        this._base.y = -this._base.height * 0.5;
        this._base.interactive = true;
        this._baseWrapper.addChild( this._base );
        
        this._dotContainer = new PIXI.Container();
        this._base.addChild( this._dotContainer );
        let dotX: number = ServiceLocator.resources[ "tut_dot_base" ].texture.width * 0.5;
        for ( let i: number = 0; i < this._kMaxSlideCount; ++i )
        {
            let dot: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources[ "tut_dot_base" ].texture );
            dot.anchor.set( 0.5 );
            dot.x = dotX;
            this._dotContainer.addChild( dot );

            dotX += 60;
        }
        this._dotContainer.position.set( this._base.width * 0.5 - this._dotContainer.width * 0.5, this._base.height - 70 );

        this._selDot = new PIXI.Sprite( ServiceLocator.resources[ "tut_dot" ].texture );
        this._selDot.anchor.set( 0.5 );
        this._selDot.position.copyFrom( this._dotContainer.getChildAt( this._curIndex ).position );
        this._dotContainer.addChild( this._selDot );

        this._closeBtn = new Button( { on: "button_close", pressed: "button_close_pressed" } );
        this._closeBtn.anchor.set( 0.5 );
        this._closeBtn.position.set( this._base.width - 50, 50 );
        this._base.addChild( this._closeBtn );

        let prevBtnWrapper: PIXI.Container = new PIXI.Container();
        prevBtnWrapper.scale.x = -1;
        prevBtnWrapper.position.set( 150, this._dotContainer.y );
        this._base.addChild( prevBtnWrapper );
        //
        this._prevBtn = new Button( { on: "button_arrow", pressed: "button_arrow_pressed" } );
        this._prevBtn.visible = this._curIndex > 0;
        this._prevBtn.anchor.set( 0.5 );
        prevBtnWrapper.addChild( this._prevBtn );

        this._nextBtn = new Button( { on: "button_arrow", pressed: "button_arrow_pressed" } );
        this._nextBtn.anchor.set( 0.5 );
        this._nextBtn.visible = this._curIndex < this._kMaxSlideCount - 1;
        this._nextBtn.position.set( this._base.width - 150, this._prevBtn.parent.y );
        this._base.addChild( this._nextBtn );

        this._closeBtn.on( "pointertap", this.onCloseBtn_Click, this );
        this._nextBtn.on( "pointertap", this.onNextBtn_Click, this );
        this._prevBtn.on( "pointertap", this.onPrevBtn_Click, this );

        this._show();
    }

        private _show(): void
        {
            this._curIndex = 0;
            this._selDot.position.copyFrom( this._dotContainer.getChildAt( this._curIndex ).position );
            /*const kTutorialInfo: any = ServiceLocator.resources.game_config.data.tutorial[  this._curIndex ];
            this._title.text = kTutorialInfo.title;
            this._message.text = kTutorialInfo.message;*/
        
            this._base.texture = ServiceLocator.resources[ "tut_module_" + this._curIndex.toString() ].texture;

            this._prevBtn.visible = false;
            this._nextBtn.visible = true;

            ServiceLocator.app.stage.on( "pointerdown", this.onStage_PointerDown, this );
        }

        private onCloseBtn_Click(): void
        {
            this._closeBtn.interactive = false;
            this._nextBtn.interactive = false;
            this._prevBtn.interactive = false;
        
            ServiceLocator.app.stage.off( "pointermove", this.onStage_PointerMove, this );
            ServiceLocator.app.stage.off( "pointerdown", this.onStage_PointerDown, this );
            ServiceLocator.app.stage.off( "pointerup", this.onStage_PointerUp, this );

            this._onClosed.dispatch( this ); 
        }

        private onPrevBtn_Click(): void
        {
            this._curIndex -= 1;

            this._selDot.position.copyFrom( this._dotContainer.getChildAt( this._curIndex ).position );

            this._prevBtn.visible = this._curIndex > 0;
            this._nextBtn.visible = true;

            this._base.texture = ServiceLocator.resources[ "tut_module_" + this._curIndex.toString() ].texture;
            
            /*const kTutorialInfo: any = ServiceLocator.resources.game_config.data.tutorial[  this._curIndex ];
            this._title.text = kTutorialInfo.title;
            this._message.text = kTutorialInfo.message;*/
        }

        private onNextBtn_Click(): void
        {
            this._curIndex += 1;

            this._selDot.position.copyFrom( this._dotContainer.getChildAt( this._curIndex ).position );

            this._nextBtn.visible = this._curIndex < this._kMaxSlideCount - 1;
            this._prevBtn.visible = true;

            this._base.texture = ServiceLocator.resources[ "tut_module_" + this._curIndex.toString() ].texture;
            
            /*const kTutorialInfo: any = ServiceLocator.resources.game_config.data.tutorial[  this._curIndex ];
            this._title.text = kTutorialInfo.title;
            this._message.text = kTutorialInfo.message;*/
        }

        private onStage_PointerDown(): void
        {
            if ( this._base.getBounds().contains( this._interactionManager.eventData.data.global.x, this._interactionManager.eventData.data.global.y ) )
            {
                this._swipeStartX = this._interactionManager.eventData.data.global.x;
    
                ServiceLocator.app.stage.on( "pointermove", this.onStage_PointerMove, this );
                ServiceLocator.app.stage.on( "pointerup", this.onStage_PointerUp, this );
            }
        }

            private onStage_PointerMove(): void
            {             
                if ( Math.abs( ( this._interactionManager.eventData.data.global.x - this._swipeStartX ) / ServiceLocator.app.root.scale.x ) >= 100 )
                {
                    let isRightSwipe: boolean = this._interactionManager.eventData.data.global.x > this._swipeStartX; 
                    if ( isRightSwipe && this._prevBtn.visible )
                    {
                        ServiceLocator.audio.playSfx( "ui_button_click" );
                        this.onPrevBtn_Click();
                    }
                    else if ( !isRightSwipe && this._nextBtn.visible )
                    {

                        ServiceLocator.audio.playSfx( "ui_button_click" );
                        this.onNextBtn_Click();
                    }

                    ServiceLocator.app.stage.off( "pointermove", this.onStage_PointerMove, this );
                    ServiceLocator.app.stage.off( "pointerup", this.onStage_PointerUp, this );
                }
            }

            private onStage_PointerUp(): void
            {
                ServiceLocator.app.stage.off( "pointermove", this.onStage_PointerMove, this );
                ServiceLocator.app.stage.off( "pointerup", this.onStage_PointerUp, this );
            }

    public end(): void
    {
        this._onClosed.dispose();
        this._onClosed = null;

        this.parent.removeChild( this._disabledBg );
        this.destroy( { children: true } );
    }

    // #endregion //
}